import * as Sentry from '@sentry/browser';

export function captureException(error: unknown): void {
  Sentry.captureException(error);
}

export { Sentry };
